// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"3d534a8bdd40c7d9","175":"05416bb22424b6f6","562":"cdee09cf99ff74ed","609":"7a6d323155100516","793":"42ef63b7ec463244","850":"9094ce8c75d867bf"}[chunkId] + ".js";
};